// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2C1e3","label":"CategoryService_label__sTrpW","location":"CategoryService_location__8qegF"};